<template>
    <div class="service">
        <div class="header">
            <div @click="onBack()"><van-icon name="arrow-left" color="white" size="22" /></div>
            <div class="tit">{{ memberInfo.memberNichen }}</div>
            <div style="width: 22px;"></div>
        </div>
        <div class="service-con" ref="serviceCon">
            <div v-for="item in historyList" class="msg" :class="item.sendReceive === 'receive' ? 'left' : 'right'">
                    <div style="display: flex;align-items: center;" v-if="item.sendReceive === 'receive'">
                         <img :src="memberInfo?.memberAvatar || '/91PORN.png'" alt="头像"
                    style="width:30px;height: 30px;border-radius: 10px;" />
                        <div class="time" style="margin-left: 3px;">{{ item.updateTime }}</div>
                    </div>
                     <div style="display: flex;align-items: center;" v-else>
                              <div class="time" style="margin-right: 3px;" >{{ item.updateTime }}</div>
                         <img :src="memberInfo?.memberAvatar || '/my/user.svg'" alt="头像"
                    style="width:30px;height: 30px;border-radius: 10px;" />
                  
                    </div>
                <div class="message" v-if="item.messageType != 'img'">{{ item.message }}</div>
                       <div class="imgmessage" v-else>
                        <img :src="item.message" style="width: 100%;height: 100%;"/>
                       </div>
            </div>
        </div>
        <div class="service-bottom">
            <div class="upload">
                <van-uploader v-model="fileList" :after-read="afterRead"  :max-count="1" :preview-image="true"
                    class="avatar-uploader">
                    <template #default>
                        <van-icon v-if="!fileList.length" name="photo-o" size="40" />
                    </template>
                </van-uploader>
            </div>
            <div>
                <van-cell-group inset>
                    <van-field v-model="message" label="" placeholder="请输入发送内容" />
                </van-cell-group>
            </div>
            <div class="send" @click="onSend()">发送</div>
        </div>
    </div>
</template>
<script setup>
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref, nextTick } from "vue"
import { post, get } from '@/utils/request'
import AES from '@/utils/aes1.js'
import CateInfoItem from "@/components/CateInfoItem.vue"
import { showFailToast,showToast } from "vant";
const router = useRouter()
const route = useRoute()
const serviceCon = ref(null)
const historyList = ref([])
const fileList = ref([])
const message = ref('');
const memberInfo = ref({})
const onBack = () => {
    router.back()
}
const file = ref()
const afterRead = async (file) => {
        const formData = new FormData()
        formData.append('file', file.file)
        const res = await post('/renren-api/api/chatim/sendPic', formData)
        console.log(res,"res");
        if(res.code === 0){
           fileList.value = []
             await onListHis()
        }
        
        // if (res.code === 0) {
        //     showToast('上传成功！')
        //     const data = {
        //         file:res.data.file
        //     }
        //     const resdata =await post('',data)
        //     console.log(resdata,"resdata");
        // }
}
const onSend = async () => {
    if (message.value != "") {
        const data = {
            content: message.value
        }
        const res = await post('/renren-api/api/chatim/send', data)
        if(res.code === 0){
          await onListHis()
           message.value = ""
        }
    }else{
        showFailToast('请输入内容')
    }
}
const onListHis = async () => {
    const res = await get('/renren-api/api/chatim/list')
    console.log(res, "res");
    if (res.code === 0) {
        historyList.value =res.data
        await onSroll()
    }

}
const onSroll =()=>{
  nextTick(() => {
    if (serviceCon.value) {
      serviceCon.value.scrollTop = serviceCon.value.scrollHeight
    }
  })
}
onMounted(async () => {
    const data = localStorage.getItem('memberInfo')
    if (data) {
        try {
            memberInfo.value = JSON.parse(data)
        } catch (err) {
            console.error('解析收藏列表失败', err)
        }
    }
    await onListHis()
})
</script>
<style lang="less" scoped>
.service {
    height: 100vh;
    padding: 5px;
    position: relative;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;

        .tit {
            font-weight: bold;
        }
    }

    .service-con {
        height: calc(100vh - 122px);
        overflow: auto;
        padding: 10px;

        .msg {
            display: flex;
            margin: 8px 0;

            &.left {
                flex-direction: column;
                justify-content: flex-start; // 靠左

                .text {
                    background: #f1f1f1;
                    color: #333;
                }
                .message{
                    background-color: var(--br-color);
                    width: 80%;
                    margin-top: 10px;
                    margin-right: 10px;
                    padding: 5px;
                    border-radius: 5px;
                }
                 .imgmessage{
                    margin-top: 10px;
                    width: 40px;
                    height: 40px;
                    border-radius: 5px;
                }
            }

            &.right {
                flex-direction: column;
                justify-content: flex-end; // 靠右
                align-items: end;

                .text {
                    background: #4caf50;
                    color: #fff;
                }
                .message{
                    background-color: var(--br-color);
                    max-width: 80%;
                    margin-top: 10px;
                    margin-right: 10px;
                    padding: 5px;
                    border-radius: 5px;
                }
                .imgmessage{
                    margin-top: 10px;
                    width: 40px;
                    height: 40px;
                    border-radius: 5px;
                }
            }
            .time{
                height: 30px;
                font-size: 12px;
                color: #cccccc;
                display: flex;
                align-items: end;
            }

            .text {
                max-width: 60%;
                padding: 8px 12px;
                border-radius: 12px;
                word-break: break-word;
            }
        }
    }

    .service-bottom {
        position: absolute;
        bottom: 0px;
        left: 0px;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        background: #333333;

        .upload {}

        .send {
            background-color: #faa500;
            color: var(--text-color);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 15px;
            border-radius: 5px;
        }
    }
 
}

/deep/ .van-cell-group--inset {
    border-radius: 4px;
    border: 1px solid var(--background-color);
    margin: 0px;
    background: var(--background-color);
}

/deep/ .van-cell {
    padding: 5px;
    background: var(--background-color);
    border-radius: 6px;

    .van-search__content {
        background: var(--background-color) !important;
    }

    .van-field__control {
        color: var(--text-color);
    }
}
/deep/ .van-image {
      width: 40px;
    height: 40px;
}
/deep/ .van-image__img{
    width: 40px;
    height: 40px;
}
</style>